import { CarCarePageContent } from '@cinch-nx/data-storyblok'
import {
  AdminFeeDrawerProvider,
  StoryblokRenderer,
} from '@in-life-and-loyalty/vaps-ui'

import styles from './vaps-feature-car-care.module.css'
import { useEffect, useState } from 'react'
import { ServicingSignInModal } from './components/sign-in-modal/servicing-sign-in-modal'
import { saveCustomerJourneyCookie } from '@cinch-labs/customer-journey-cookies'

export interface VapsFeatureCarCareProps {
  children?: React.ReactNode
  content: CarCarePageContent
}

const VapsFeatureCarCare: React.FC<VapsFeatureCarCareProps> = ({ content }) => {
  const [openModal, setOpenModal] = useState<boolean>(false)

  useEffect(() => {
    saveCustomerJourneyCookie()

    const ctaLink = document.querySelector(
      "a[href='/car-care/servicing/book']",
    ) as HTMLElement
    if (!ctaLink) return

    const parentWrapper = ctaLink.closest(
      'div[class*="wrapper_wrapper"]',
    ) as HTMLElement
    if (!parentWrapper) return

    const originalOffsetTop = parentWrapper.offsetTop

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop

      if (scrollTop >= originalOffsetTop) {
        parentWrapper.style.setProperty('position', 'fixed', 'important')
        parentWrapper.style.setProperty('top', '0', 'important')
        parentWrapper.style.setProperty('left', '0', 'important')
        parentWrapper.style.setProperty('right', '0', 'important')
        parentWrapper.style.setProperty('width', '100%', 'important')
        parentWrapper.style.setProperty('max-height', '75px', 'important')
        parentWrapper.style.setProperty('max-width', '100%', 'important')
        parentWrapper.style.setProperty(
          'background-color',
          '#ffffff',
          'important',
        )
        parentWrapper.style.setProperty(
          'box-shadow',
          '0 4px 12px rgb(0 0 0 / 15%)',
          'important',
        )
        parentWrapper.style.setProperty('z-index', '1000', 'important')
        parentWrapper.style.setProperty('margin', '0', 'important')
        parentWrapper.style.setProperty('padding', '12px 16px', 'important')
      } else {
        parentWrapper.style.removeProperty('position')
        parentWrapper.style.removeProperty('top')
        parentWrapper.style.removeProperty('left')
        parentWrapper.style.removeProperty('right')
        parentWrapper.style.removeProperty('width')
        parentWrapper.style.removeProperty('max-height')
        parentWrapper.style.removeProperty('max-width')
        parentWrapper.style.removeProperty('background-color')
        parentWrapper.style.removeProperty('box-shadow')
        parentWrapper.style.removeProperty('z-index')
        parentWrapper.style.removeProperty('margin')
        parentWrapper.style.removeProperty('padding')
      }
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  if (!content) return null

  const onClose = () => setOpenModal(false)

  const wrappedComponents = content.body
    .map((el) => el.component)
    .filter(
      (el) =>
        el !== 'FeatureImageCardSection' &&
        el !== 'PeaceOfMind' &&
        el !== 'FeatureIconCardSection' &&
        el !== 'FeaturedEVsCarousel' &&
        el !== 'FinanceExample' &&
        el !== 'HowToGetCinchCharge',
    )

  const limitedItems: { [key: string]: number } = {}

  return (
    <article className={styles.mainSection}>
      <AdminFeeDrawerProvider>
        <StoryblokRenderer
          block={content.body}
          componentsWithWrapper={wrappedComponents}
          limitedItems={limitedItems}
        />
        {openModal && <ServicingSignInModal onClose={onClose} />}
      </AdminFeeDrawerProvider>
    </article>
  )
}

export default VapsFeatureCarCare
